import { DAY_MS, type Session } from "@jackedlogs/shared";

// Session-count summaries behind the Progress footer (lifted from mobile's
// progressScreenMath). The frequency bar chart + the total/7d/30d/last
// stats read these.

const WEEK_MS = 7 * DAY_MS;
export const FREQ_WEEKS = 12;

export type SessionSummary = {
  total: number;
  last7d: number;
  last30d: number;
  lastSession: Session | null;
};

export function computeSessionSummary(
  sessions: Session[],
  nowMs: number,
): SessionSummary {
  let last7d = 0;
  let last30d = 0;
  let lastSession: Session | null = null;
  let lastT = 0;
  for (const s of sessions) {
    const at = new Date(s.startedAt).getTime();
    if (nowMs - at <= 7 * DAY_MS) last7d++;
    if (nowMs - at <= 30 * DAY_MS) last30d++;
    if (at > lastT) {
      lastT = at;
      lastSession = s;
    }
  }
  return { total: sessions.length, last7d, last30d, lastSession };
}

// Widened to the one field it reads (CO-9): the coach detail buckets the
// athlete's session-results (which carry only a timestamp), while the mobile
// host keeps passing full Session rows — structurally compatible, no change.
export function computeWeeklyCounts(
  sessions: ReadonlyArray<Pick<Session, "startedAt">>,
  nowMs: number,
  weeks: number = FREQ_WEEKS,
): number[] {
  const out = new Array<number>(weeks).fill(0);
  for (const s of sessions) {
    const at = new Date(s.startedAt).getTime();
    const ago = nowMs - at;
    if (ago < 0) continue;
    const weekIdx = weeks - 1 - Math.floor(ago / WEEK_MS);
    if (weekIdx < 0 || weekIdx >= weeks) continue;
    out[weekIdx] = (out[weekIdx] ?? 0) + 1;
  }
  return out;
}
